import React, { useState, useEffect } from "react";
import "./CustomCarousel.css"; // We'll create this CSS file next

const CustomCarousel = ({ items, autoplayInterval = 5000, showIndicators = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + items.length) % items.length
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Autoplay logic
  useEffect(() => {
    const interval = setInterval(nextSlide, autoplayInterval);
    return () => clearInterval(interval); // Cleanup on unmount
  }, [autoplayInterval]);

  return (
    <div className="custom-carousel-container">
      <div className="carousel-items" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
        {items.map((item, index) => (
          <div
            key={index}
            className={`carousel-item ${index === currentIndex ? "active" : ""}`}
          >
            {item}
          </div>
        ))}
      </div>

      {/* Prev Button */}
      <button className="carousel-prev" onClick={prevSlide}>
        &#10094;
      </button>

      {/* Next Button */}
      <button className="carousel-next" onClick={nextSlide}>
        &#10095;
      </button>

      {showIndicators && (
        <div className="carousel-indicators">
          {items.map((_, index) => (
            <span
              key={index}
              className={`indicator ${index === currentIndex ? "active" : ""}`}
              onClick={() => goToSlide(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomCarousel;
